import App from './App.svelte.js';

function index (settings) {
    new App({
        target: document.body,
        props: {
            settings,
        },
    });
}

export { index as default };
//# sourceMappingURL=index.js.map
